import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message, notification, Popconfirm, Typography} from 'antd';
import {Route, Switch} from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import UpdateWithAsset from './updateWithAssset';
import {
  createResource,
  deleteResource,
  fetchResource,
  getResource,
  saveResourceQuery,
  updateResource,
} from "../../appRedux/actions/Document";
import {fetchResource as fetchAsset} from "../../appRedux/actions/Asset";
import {
  clearDocumentReportProps,
  fetchAllFiltersData,
  fetchAssetCodes,
  fetchDocumentAssetReportData,
  fetchDocumentType,
  fetchFilter,
  getEquipmentSubTypeByAssetTypes
} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import Report from "../Document/report";
import * as moment from 'moment';

const {Title} = Typography;

export class Document extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    const {match} = this.props;
    // console.log(match);
    if(match.isExact) {
      this.fetchList();
    }
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({visibleColumns: columns}, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const {resourceName} = this.props;

    Object.keys(filters).forEach((item) => {

      if(item === '_id') {
        return;
      }

      if(selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>Edit</Button>
          }}/>

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={() => {
                this.deleteResource(record._id)
              }}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button style={{marginLeft: '10px'}} type="danger" size='small'>Delete</Button>
            </Popconfirm>
          }}/>

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    const payload = {
      file: values.files.file,
      name: values.name,
      type: values.type,
    };

    if(values.renewalDate) {
      payload.renewalDate = values.renewalDate;
    }
    if(values.documentDate) {
      payload.documentDate = values.documentDate;
    }
    if(values.amount) {
      payload.amount = values.amount;
    }
    this.props.createResource(payload);
  };

  fetchAssetCodes = (location, client, subType, assetType, assetCode) => {
    this.props.fetchAssetCodes(location, client, subType, assetType, assetCode);
  }

  updateResource = (values, id) => {
    const payload = {
      file: (values.files.file && values.files.file) || {},
      name: values.name,
      type: values.type,
      amount: values.amount,
      renewalDate: values.renewalDate,
      documentDate: values.documentDate,
    };
    this.props.updateResource(payload, id);
  };

  updateDocWithAssetResource = (values, id) => {
    const payload = {
      _id: values._id,
      file: (values.files.file && values.files.file) || {},
      name: values.name,
      type: values.type,
      docTypeObject: values.docType,
      amount: values.amount,
      renewalDate: values.renewalDate,
      documentDate: values.documentDate,
      asset: values.asset,
      existingDocuments: values.documents || [],
    };
    // =======================
    // const data = {
    //   file: values.files.file,
    //   name: values.name,
    //   renewalDate: values.renewalDate,
    //   documentDate: values.documentDate,
    //   type: values.type,
    //   docTypeObject: values.docType,
    //   amount: values.amount || 0,
    // };
    let overlappedFlag = false;
    let fixedOverlapped = [];
    if(payload.docTypeObject.isOverlappedDisabled && payload.existingDocuments) {
      const overlapped = payload.existingDocuments.map(doc => {
        if(doc && doc.type === payload.type && doc._id !== payload._id) {
          const {documentDate, renewalDate} = doc;
          const {documentDate: currentDocumentDate, renewalDate: currentRenewalDate} = payload;
          if(moment(currentDocumentDate).isBetween(moment(documentDate).format('YYYY-MM-DD'), moment(renewalDate).format('YYYY-MM-DD'), undefined, '[]')
            || moment(currentRenewalDate).isBetween(moment(documentDate).format('YYYY-MM-DD'), moment(renewalDate).format('YYYY-MM-DD'), undefined, '[]')) {
            return {documentName: payload.name, overlappedDocumentName: doc.name, overlappedDocumentId: doc._id}; // `${payload.name} has been overlapped with ${doc.name}`;
          }
        }
      });
      fixedOverlapped = overlapped.filter(o => o);
      if(fixedOverlapped && fixedOverlapped.length)
        overlappedFlag = true;
    }

    // =======================
    if(payload.existingDocuments) {
      if(!overlappedFlag) {
        this.props.updateResource(payload, id);
      } else {
        // message.error(`Cannot upload ! ${fixedOverlapped.join('/')}`);
        fixedOverlapped.map((msg, key) => {
          notification.error({
            key,
            duration: 30,
            message: `Document Upload Error!`,
            description: <>
              <Title level={4}>{`Document ${msg.documentName} is overlapped with ${msg.overlappedDocumentName}`}</Title>
              <a target='_blank'
                 href={`/document/edit/${msg.overlappedDocumentId}`}>{`Edit ${msg.overlappedDocumentName}`}</a>
            </>,
          })
        });
      }
    }
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  getUrl = (id) => {
    const {match} = this.props;
    return `${match.url}/edit/${id}`;
  };

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName} = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);

    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <List columns={columns}
                                   visibleColumn={visibleColumns}
                                   data={data}
                                   clearFilter={this.clearAll}
                                   filters={filters}
                                   handleChange={this.handleChange}
                                   columnChange={this.handleColumnChange}
                                   title={resourceName}
                                   size={'middle'}
                                   create={this.create}
                                   pagination={this.props.query.pagination}
                                   loading={loading}
                                   authUser={authUser}
               />
               }/>
        <Route path={`${match.url}/add`}
               render={(props) => <Create data={{}}
                                          filters={filters}
                                          modules={modules}
                                          title={'CREATE'}
                                          resource={resourceName}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.createResource}
                                          loading={loading}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/report`}
               render={(props) => <Report data={{}}
                                          getUrl={this.getUrl}
                                          filters={filters}
                                          subDocumentFilters={this.props.subDocumentFilters}
                                          documentFilters={this.props.documentFilters}
                                          assetCodes={this.props.assetCodes}
                                          modules={modules}
                                          title={'REPORT'}
                                          resource={resourceName}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.createResource}
                                          fetchAssetCodes={this.fetchAssetCodes}
                                          fetchAllFiltersData={this.props.fetchAllFiltersData}
                                          fetchDocumentType={this.props.fetchDocumentType}
                                          documentTypes={this.props.documentType}
                                          getEquipmentSubTypeByAssetTypes={this.props.getEquipmentSubTypeByAssetTypes}
                                          fetchDocumentAssetReportData={this.props.fetchDocumentAssetReportData}
                                          equipmentSubTypes={this.props.equipmentSubTypes}
                                          tableAssetData={this.props.tableAssetData}
                                          tableDocumentTypeData={this.props.tableDocumentTypeData}
                                          clearDocumentReportProps={this.props.clearDocumentReportProps}
                                          loading={loading}
                                          authUser={this.props.authUser}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/edit/:id/:asset?`}
               render={(props) => <Create data={edit}
                                          filters={filters}
                                          modules={modules}
                                          title={'EDIT'}
                                          resource={resourceName}
                                          fetch={fetchResource}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.updateResource}
                                          deleteResource={this.deleteResource}
                                          loading={loading}
                                          {...props}
               />
               }/>

        <Route path={`${match.url}/editAsset/:id/:asset`}
               render={(props) => <UpdateWithAsset data={edit}
                                                   filters={filters}
                                                   modules={modules}
                                                   title={'EDIT'}
                                                   resource={resourceName}
                                                   fetch={fetchResource}
                                                   fetchAsset={this.props.fetchAsset}
                                                   assetData={this.props.assetData}
                                                   onChange={this.handleFormChange}
                                                   onSubmit={this.updateDocWithAssetResource}
                                                   deleteResource={this.deleteResource}
                                                   loading={loading}
                                                   {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, asset, document, commonData}) => {
  return {
    authUser: auth.authUser,
    total: document.total,
    data: document.resources,
    resource: document.resource,
    edit: document.edit,
    assetData: asset.edit,
    query: document.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    assetCodes: commonData.assetCodes,
    documentFilters: commonData.documentFilters,
    documentType: commonData.documentType,
    equipmentSubTypes: asset.equipmentSubTypes,
    tableAssetData: commonData.tableAssetData,
    tableDocumentTypeData: commonData.tableDocumentTypeData,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    createResource,
    fetchResource,
    fetchAllFiltersData,
    fetchAssetCodes,
    fetchDocumentType,
    clearDocumentReportProps,
    getEquipmentSubTypeByAssetTypes,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    fetchDocumentAssetReportData,
    fetchAsset,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(Document);
